// import path from "path";
import React from "react";

const MainLayout = React.lazy(
  () => import("../../components/Layout/MainLayout")
);
const ViewerLayout = React.lazy(
  () => import("../../components/Layout/ViewerLayout")
);
const AuthLayout = React.lazy(
  () => import("../../components/Layout/AuthLayout")
);
const ConnectorsPage = React.lazy(
  () => import("../ConnectorPage/ConnectorPage")
);
const DrivePage = React.lazy(() => import("../DrivePage/DrivePage"));
const ViewerPage = React.lazy(() => import("../ViewerPage/ViewerPage"));
const LoginPage = React.lazy(() => import("../LoginPage/LoginPage"));
const PdfViewerViewLayout = React.lazy(
  () => import("../PdfviewerViewFile/PdfViewerViewLayout")
);
const NotFoundPage = React.lazy(() => import("../NotFoundPage/NotFoundPage"));
const CreateProject = React.lazy(
  () => import("../AccountPage/components/createproject/CreateProject")
);
const MainViewer = React.lazy(() => import("../main-viewer"));
// const TestRabbitMq = React.lazy(()=> import("@/pages/Test/TestRabbitMq"))
const TestWorkflow = React.lazy(()=> import("@/pages/Test/TestWorkflow"))
const SheetViewer = React.lazy(()=> import("@/pages/SheetPage/SheetViewer"))
const ChatbotPage = React.lazy(()=> import("@/pages/Chatbot/ChatbotPage"))
const TrashPage = React.lazy(() => import("../TrashPage/TrashPage"))
const EmptyOrganizationsPage = React.lazy(() => import("../EmptyOrganizationsPage/EmptyOrganizationsPageWrapper"))
const SettingPage = React.lazy(() => import("../SettingPage/SettingPage"))
const GroupUserTab = React.lazy(() => import("../SettingPage/components/GroupUserTab"))
const SystemSettingTab = React.lazy(() => import("../SettingPage/components/SystemSettingTab"))
const GroupDetailPage = React.lazy(() => import("../SettingPage/components/GroupDetailPage"))
const StorageManagement = React.lazy(() => import("../SettingPage/StorageManagement/StorageManagement"))

const RouterArr = [
  {
    path: "/page",
    component: MainLayout,
    exact: true,
    isNotPrivate: true,
    children: [
      {
        index: true,
        component: DrivePage,
        isNotPrivate: true,
      },
      {
        path: "connectors",
        component: ConnectorsPage,
        isNotPrivate: true,
      },
      {
        // Unified drive route - workspace determined by Redux state
        path: "drive",
        component: DrivePage,
        isNotPrivate: true,
      },

      // {
      //   path: "trash",
      //   component: TrashPage,
      //   isNotPrivate: true,
      // },

      {
        path: "empty-organizations",
        component: EmptyOrganizationsPage,
        isNotPrivate: true,
      },

      {
        path: "settings",
        component: SettingPage,
        isNotPrivate: true,
        requireAdmin: true,
        children: [
          {
            path: "groups",
            component: GroupUserTab,
          },
          {
            path: "system",
            component: SystemSettingTab,
          },
          {
            path: "storage",
            component: StorageManagement,
          },
        ],
      },

      {
        path: "settings/groups/:groupId",
        component: GroupDetailPage,
        isNotPrivate: true,
        requireAdmin: true,
      },

      {
        //dùng để xem file pdf ,src là đường dẫn của file pdf nhưng mà đang có 1 vấn đề là không thể nhúng pdf view vào trong table tab được
        path: "pdf/view",
        component: PdfViewerViewLayout,
        isNotPrivate: true,
      },
    ],
  },
  // {
  //   path: "projects",
  //   component: AccountPage,
  //   exact: true,
  //   isNotPrivate: true,
  // },
  
  {
    path: "chatbot",
    component: ChatbotPage,
    exact: true,
    isNotPrivate: true,
  },

  {
    path: "/mainviewer",
    component: MainViewer,
    exact: true,
    isNotPrivate: true,
  },
  {
    path: "/projects/new",
    component: CreateProject,
    exact: true,
    isNotPrivate: true,
  },
  
  // {
  //   path: "/test",
  //   component: TestRabbitMq,
  //   exact: true,
  //   isNotPrivate: true,
  // },

  {
    path: "/test2",
    component: TestWorkflow,
    exact: true,
    isNotPrivate: true,
  },

  {
    path: "/sheet",
    component: SheetViewer,
    exact: true,
    isNotPrivate: true,
  },
  {
    path: "/viewer",
    component: ViewerLayout,
    isNotPrivate: true,
    children: [
      {
        index: true,
        component: ViewerPage,
        isNotPrivate: true,
      },
    ],
  },
  {
    path: "/auth",
    component: AuthLayout,
    exact: true,
    isNotPrivate: true,
    children: [
      {
        path: "login",
        component: LoginPage,
        isNotPrivate: true,
      },
    ],
  },
  {
    path: "*",
    component: NotFoundPage,
    isNotPrivate: true,
  },
];

export default RouterArr;
